<template>
  <div class="position-relative">
<!--  Invisible placeholder to leave space for the icons  -->
<!--  TODO: The hover is a bit eager. A debounce would be nice here.   -->
    <div
      id="sidebar-icons"
      class="position-relative"
      style="z-index: -1; width: 60px;"
    ></div>
    <ul
      id="sidebar"
      class="list-unstyled components position-fixed"
      :class="{ active: hovering }"
      @mouseenter="mouseEnter"
      @mouseleave="collapseAll"
    >
      <SidebarItem
        ref="sidebarItems"
        v-for="(nav, index) in navigation"
        :key="index"
        :dropdown="nav.dropdown"
        :href="nav.dropdown ? '' : nav.href"
        :icon="nav.icon"
        :index="index"
        :name="nav.name"
        :sub-navigation="nav.dropdown ? nav.subNavigation : []"
        :disabled="nav.hasOwnProperty('disabled') ? nav.disabled : false"
      ></SidebarItem>
    </ul>
  </div>
</template>

<script>
import SidebarItem from './SidebarItem.vue';

// const debounce = require('lodash/debounce');

export default {
  name: 'TheSidebar',
  components: { SidebarItem },
  data() {
    return {
      navigation: [
        {
          name: 'Account',
          icon: 'person-circle',
          dropdown: false,
          href: '/settings/account',
        },
        {
          name: 'Dashboard',
          icon: 'columns-gap',
          dropdown: false,
          href: '/dash',
        },
        {
          name: 'Search',
          icon: 'search',
          dropdown: false,
          href: '/search',
        },
        {
          name: 'New Shipment',
          icon: 'box',
          dropdown: false,
          href: '/shipment',
          disabled: !this.can('Booking Details', 'manage'),
        },
        {
          name: 'New Manifest',
          icon: 'card-list',
          dropdown: false,
          href: '/manifest-proto',
          disabled: !this.can('Manifest Details', 'manage'),
        },
        {
          name: 'Analytics',
          icon: 'bar-chart-line',
          dropdown: true,
          collapse: true,
          disabled: !this.can('Analytics-Dashboard', 'read only'),
          subNavigation: [
            {
              name: 'Create Manifest Report',
              href: '#',
              disabled: true,
            },
            {
              name: 'Warehouse Inventory Report',
              href: '#',
              disabled: true,
            },
            {
              name: 'Create Delivery Report',
              href: '#',
              disabled: true,
            },
          ],
        },
        {
          name: 'Sign Out',
          icon: 'box-arrow-left',
          dropdown: false,
          href: '/',
        },
      ],
      hovering: false,
    };
  },
  methods: {
    collapseAll() {
      const navigation = this.$refs.sidebarItems;
      for (let idx = 0; idx < navigation.length; idx += 1) {
        if (navigation[idx].collapse !== undefined) {
          navigation[idx].collapse = false;
        }
      }
      this.hovering = false;
      this.$emit('mouseleave');
    },
    mouseEnter() {
      // return debounce(() => {
      this.hovering = true;
      this.$emit('mouseenter');
      // }, 200);
    },
  },
};
</script>

<style>
#sidebar-icons {
  background: var(--primary-color);
  text-align: left;
  min-height: 100vh;
  padding-top: 60px;
}

#sidebar {
  background: var(--primary-color);
  text-align: left;
  min-height: 100vh;
  padding-top: 140px;
  top: 0;
  z-index: 5;
  max-width: 60px;
  overflow-x: hidden;
  width: 240px;
  transition: max-width 0.3s ease;
}

#sidebar.active {
  max-width: 240px;
}

#sidebar ul p {
  color: #fff;
  padding: 10px;
}

#sidebar ul > li {
  position: relative;
}

#sidebar li a,
#sidebar li button {
  padding: 0.375rem 0.75rem;
  display: block;
  width: 100%;
  text-align: left;
  border-radius: 0;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  position: relative;
}

#sidebar ul li a.disabled,
#sidebar ul li button.disabled {
  color: darkgray !important;
}

#sidebar>li>a:hover {
  color: var(--side-font-color) !important;
  background: var(--hover-color);
}

#sidebar ul li:hover,
#sidebar li button:hover {
  color: var(--side-font-color);
  background: var(--hover-color);
}

#sidebar ul li.active>a,
#sidebar a[aria-expanded="true"],
#sidebar ul li.active>button,
#sidebar button[aria-expanded="true"] {
  color: var(--side-font-color);
}

#sidebar .dropdown-toggle::after {
  margin-right: 5px;
  transition: all .25s ease-out;
  transform: rotate(0turn);
}

#sidebar li>a[aria-expanded="false"].dropdown-toggle::after,
#sidebar li>button[aria-expanded="false"].dropdown-toggle::after {
  transition: all .25s ease-out;
  transform: rotate(-0.25turn);
}

#sidebar a {
  color: white !important;
}

#sidebar ul {
  font-size: 0.9em !important;
  background: var(--secondary-color);
}

.collapse {
  margin-top: 0 !important;
}
</style>
